var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMontasLogoMinimalistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_369",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000038411519112784283530000005758506875743689353_);}\n\t.st1{fill:url(#Rechteck_2_00000105404982708889067650000007725435260507732642_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#E30613;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1.2,20.7c0,4.5,1.6,8.8,4.5,12.2l6.4-6.4c-3.2-4.4-2.3-10.5,2-13.8c4.4-3.2,10.5-2.3,13.8,2 c2.6,3.5,2.6,8.2,0,11.7l6.4,6.4c6.8-7.9,5.9-19.8-2-26.5c-8-6.7-19.8-5.7-26.6,2.1C2.8,11.9,1.2,16.2,1.2,20.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181048456890092718220000001369712150934125958_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3",
    style: {
      clipPath: "url(#SVGID_00000181048456890092718220000001369712150934125958_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Rechteck_2_00000173875267954805622670000003048204503080314301_",
    cx: -623.6972,
    cy: 300.9431,
    r: 0.555,
    gradientTransform: "matrix(31.084 0 0 31.066 19393.2578 -9239.2588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#130C0E"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2",
    x: 1.2,
    y: 1.9,
    style: {
      fill: "url(#Rechteck_2_00000173875267954805622670000003048204503080314301_)"
    },
    width: 37.6,
    height: 31.1
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1",
    className: "st2",
    d: "M13.1,38.2l6.9-6.9l6.9,6.9c2.9-1.1,5.4-2.9,7.4-5.3l-6.4-6.4L20,18.6l-7.9,7.9l-6.4,6.4 C7.7,35.3,10.2,37.1,13.1,38.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMontasLogoMinimalistic);
export default __webpack_public_path__ + "static/media/montas_logo_minimalistic.9c684d99e0457ac98ffbcb4008ab250e.svg";
export { ForwardRef as ReactComponent };